import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { UserAccount } from 'types/user';

export const USER_ACCOUNT_KEY = 'userAccount';

export function useUserAccount(disabled?: boolean) {
  const url = '/users/account';
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);

  return useQuery({
    queryKey: [USER_ACCOUNT_KEY],
    queryFn: () =>
      request(url, {
        method: 'GET',
      })
        .then<UserAccount>(res => ({
          ...res,
          expirationDate: parseISO(res.expirationDate),
        }))
        .catch(err => {
          if (err?.response?.status === 401) {
            notifyError({
              title: t('common:components.user.disconnectedError'),
            });
            return;
          }
          notifyError({
            title: t('common:components.user.fetchGenericError'),
          });
        }),

    refetchOnWindowFocus: false,

    // 30 mins
    staleTime: 30 * (60 * 1000),

    // 35 mins
    gcTime: 35 * (60 * 1000),

    enabled: !disabled,
  });
}
